import { Box, CircularProgress, Grid, Stack } from "@mui/material";
import { COLOR_LESS_BLACK } from "../../../../../../data/colors/Colors";
import { useEffect, useState } from "react";
import { ROUTE_ENDPOINTS } from "../../../../../../data/constant/RouteConstants";
import { EmptyView } from "../../../../../component/EmptyView";
import { Question } from "../../../../../../domain/model/Question";
import { QuestionsListItemView } from "../questionsListItemView/QuestionsListItemView";

interface p {
  selectedCategoryId?: string;
  questions: Array<Question> | undefined;
  getQuestions: (categoryId: string) => void;
  setShowDeleteAlertDialog: (show: boolean) => void;
  setSelectedQuestionId: (id: string | undefined) => void;
}

export function FilteredCategoryView(p: p) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (p.selectedCategoryId && !p.questions) {
      setLoading(true);
      p.getQuestions(p.selectedCategoryId);
    }
  }, [p.selectedCategoryId]);

  useEffect(() => {
    if (p.questions) {
      setLoading(false);
    }
  }, [p.questions]);

  return (
    <Stack>
      {loading ? (
        <Box
          width={"100%"}
          height={100}
          alignItems={"center"}
          justifyContent={"center"}
          display={"flex"}
          flexDirection={"column"}
        >
          <CircularProgress sx={{ color: COLOR_LESS_BLACK }} />
        </Box>
      ) : (
        <Grid container spacing={1} sx={{ mt: 1 }}>
          {p.questions && p.questions.length > 0 ? (
            p.questions.map((question, index) => {
              return (
                <Grid size={{ xs: 12, md: 6 }} key={question._id}>
                  <QuestionsListItemView
                    question={question}
                    onDeleteClicked={() => {
                      p.setShowDeleteAlertDialog(true);
                      p.setSelectedQuestionId(question._id);
                    }}
                    index={index}
                    href={`${ROUTE_ENDPOINTS.HOME_QUESTIONS}/${question._id}`}
                  />
                </Grid>
              );
            })
          ) : (
            <EmptyView minHeight={100} />
          )}
        </Grid>
      )}
    </Stack>
  );
}
